<template>
  <ul class="menu-nav">
    <template v-for="(level1, index1) in menuList">
      <li class="menu-item" v-if="level1.external" :key="index1 + 'L1'">
        <a class="menu-link" :href="level1.link" target="_blank">
          <i class="menu-icon" :class="level1.icon"></i>
          <span class="menu-text">{{ level1.name }}</span>
        </a>
      </li>

      <li
        class="menu-item"
        @click="logOut()"
        v-else-if="level1.exit"
        :key="index1 + 'L1'"
      >
        <p @click="logOut()" class="menu-link">
          <i class="menu-icon" :class="level1.icon"></i>
          <span class="menu-text">{{ level1.name }}</span>
        </p>
      </li>
      <template v-else>
        <router-link
          :key="index1 + 'L1'"
          v-if="level1.root"
          :to="level1.link"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li
            @click="
              addtab(href, level1.name);
              clearStore();
            "
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
              isActive && 'menu-item-active',
              isExactActive && 'menu-item-active',
            ]"
          >
            <a :href="href" class="menu-link" @click="navigate">
              <i class="menu-icon" :class="level1.icon"></i>
              <span class="menu-text">{{ level1.name }}</span>
              <span v-if="level1.notif" class="menu-label">
                <span class="label label-rounded label-primary">{{
                  level1.notif
                }}</span>
              </span>
            </a>
          </li>
        </router-link>
        <li
          v-else
          :key="index1 + 'L1'"
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          v-bind:class="{
            'menu-item-open': hasActiveChildren(level1.link),
          }"
        >
          <a href="#" class="menu-link menu-toggle">
            <i class="menu-icon" :class="level1.icon"></i>
            <span class="menu-text">{{ level1.name }}</span>
            <i class="menu-arrow"></i>
          </a>

          <div class="menu-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <li aria-haspopup="true" class="menu-item menu-item-parent">
                <span class="menu-link">
                  <span class="menu-text">{{ level1.name }}</span>
                </span>
              </li>
              <template v-for="(level2, index2) in level1.childs">
                <router-link
                  :key="index2 + 'L2'"
                  v-if="level2.root"
                  :to="level2.link"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    @click="
                      addtab(href, level2.name);
                      clearStore();
                    "
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
                      isActive && 'menu-item-active',
                      isExactActive && 'menu-item-active',
                    ]"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <i class="menu-icon" :class="level2.icon"></i>
                      <span class="menu-text">{{ level2.name }}</span>
                    </a>
                  </li>
                </router-link>
                <!-- --------------inv.sepehrparsayan.ir--------------- -->
                <li
                  class="menu-item"
                  v-else-if="level2.external"
                  :key="index2 + 'L2'"
                >
                  <a class="menu-link" :href="level2.link" target="_blank">
                    <i class="menu-icon" :class="level2.icon"></i>
                    <span class="menu-text">{{ level2.name }}</span>
                  </a>
                </li>
                <!-- -------------------------------------------------- -->
                <li
                  v-else
                  :key="index2 + 'L2'"
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item menu-item-submenu"
                  v-bind:class="{
                    'menu-item-open': hasActiveChildren(level2.link),
                  }"
                >
                  <a href="#" class="menu-link menu-toggle">
                    <i class="menu-icon" :class="level2.icon"></i>
                    <span class="menu-text">{{ level2.name }}</span>
                    <i class="menu-arrow"></i>
                  </a>

                  <div class="menu-submenu">
                    <span class="menu-arrow"></span>
                    <ul class="menu-subnav">
                      <li
                        aria-haspopup="true"
                        class="menu-item menu-item-parent"
                      >
                        <span class="menu-link">
                          <span class="menu-text">{{ level2.name }}</span>
                        </span>
                      </li>
                      <template v-for="(level3, index3) in level2.childs">
                        <router-link
                          :key="index3 + 'L3'"
                          v-if="level3.root"
                          :to="level3.link"
                          v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                          <li
                            @click="addtab(href, level3.name)"
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                              isActive && 'menu-item-active',
                              isExactActive && 'menu-item-active',
                            ]"
                          >
                            <a :href="href" class="menu-link" @click="navigate">
                              <i class="menu-icon" :class="level3.icon"></i>
                              <span class="menu-text">{{ level3.name }}</span>
                            </a>
                          </li>
                        </router-link>
                        <li
                          v-else
                          :key="index3 + 'L3'"
                          aria-haspopup="true"
                          data-menu-toggle="hover"
                          class="menu-item menu-item-submenu"
                          v-bind:class="{
                            'menu-item-open': hasActiveChildren(level3.link),
                          }"
                        >
                          <a href="#" class="menu-link menu-toggle">
                            <i class="menu-icon" :class="level3.icon"></i>
                            <span class="menu-text">{{ level3.name }}</span>
                            <i class="menu-arrow"></i>
                          </a>

                          <div class="menu-submenu">
                            <span class="menu-arrow"></span>
                            <ul class="menu-subnav">
                              <li
                                aria-haspopup="true"
                                class="menu-item menu-item-parent"
                              >
                                <span class="menu-link">
                                  <span class="menu-text">{{
                                    level3.name
                                  }}</span>
                                </span>
                              </li>
                              <template
                                v-for="(level4, index3) in level3.childs"
                              >
                                <router-link
                                  :key="index3 + 'L3'"
                                  v-if="level4.root"
                                  :to="level4.link"
                                  v-slot="{
                                    href,
                                    navigate,
                                    isActive,
                                    isExactActive,
                                  }"
                                >
                                  <li
                                    @click="addtab(href, level4.name)"
                                    aria-haspopup="true"
                                    data-menu-toggle="hover"
                                    class="menu-item"
                                    :class="[
                                      isActive && 'menu-item-active',
                                      isExactActive && 'menu-item-active',
                                    ]"
                                  >
                                    <a
                                      :href="href"
                                      class="menu-link"
                                      @click="navigate"
                                    >
                                      <i
                                        class="menu-icon"
                                        :class="level4.icon"
                                      ></i>
                                      <span class="menu-text">{{
                                        level4.name
                                      }}</span>
                                    </a>
                                  </li>
                                </router-link>
                                <li
                                  v-else
                                  :key="index3 + 'L3'"
                                  aria-haspopup="true"
                                  data-menu-toggle="hover"
                                  class="menu-item menu-item-submenu"
                                  v-bind:class="{
                                    'menu-item-open': hasActiveChildren(
                                      level4.link
                                    ),
                                  }"
                                >
                                  <a href="#" class="menu-link menu-toggle">
                                    <i
                                      class="menu-icon"
                                      :class="level4.icon"
                                    ></i>
                                    <span class="menu-text">{{
                                      level4.name
                                    }}</span>
                                    <i class="menu-arrow"></i>
                                  </a>

                                  <div class="menu-submenu">
                                    <span class="menu-arrow"></span>
                                    <ul class="menu-subnav">
                                      <li
                                        aria-haspopup="true"
                                        class="menu-item menu-item-parent"
                                      >
                                        <span class="menu-link">
                                          <span class="menu-text">{{
                                            level4.name
                                          }}</span>
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </template>
                            </ul>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </li>
      </template>
    </template>
  </ul>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'KTMenu',
  data() {
    return {
      menuList: [],
      userBusinessInformation: null,
    };
  },
  computed: {
    ...mapGetters(['userDetails']),

    currentMerchantObject() {
      return this.$store.getters.currentMerchantObject;
    },
  },
  created() {
    let app = this;
    if (this.userDetails.roles.includes('supplier')) {
      if (this.$store.getters.currentMerchant) {
        this.$store
          .dispatch('getMerchantInformation')
          .then((data) => {
            app.userBusinessInformation = data;
          })
          .catch((error) => {});
      }
    } else {
      this.$store
        .dispatch('getSupplierInformation')
        .then((data) => {
          app.userBusinessInformation = data;
        })
        .catch((err) => console.log(err));
    }
  },
  mounted() {
    this.items();
  },

  watch: {
    '$store.getters.currentMerchant': function () {
      if (this.userDetails.roles.includes('supplier')) {
        this.$store
          .dispatch('getMerchantInformation')
          .then((data) => {
            this.userBusinessInformation = data;
          })
          .catch((error) => {});
      } else {
        this.$store
          .dispatch('getSupplierInformation')
          .then((data) => {
            this.userBusinessInformation = data;
          })
          .catch((err) => console.log(err));
      }
    },
    userBusinessInformation() {
      this.items();
    },
    currentMerchantObject(after, before) {
      if (after) {
        this.items();
      }
    },
  },
  methods: {
    ...mapActions('oidc', [
      'signOutOidc',
      'authenticateOidc',
      'signOutOidcSilent',
    ]),
    clearStore() {
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestCategoryType', null);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestResponsesPerItem', null);
      this.$store.commit('setTradeRequestNumber', null);
      this.$store.commit('setTradeRequestDate', null);
      this.$store.commit('setTradeRequestResponsesHeader', null);
      this.$store.commit('setTradeRequestSelectedForResponse', null);
    },
    logOut() {
      localStorage.removeItem('activeTab');
      this.signOutOidcSilent();
    },
    checkMerchantIsConsumer() {},
    items() {
      try {
        const userRoles = this.userDetails.roles;
        if (
          userRoles &&
          !userRoles.includes('supplier') &&
          !this.$store.getters.userBusinessInformation.isSupplier
        ) {
          import('@/core/helpers/const.js').then((res) => {
            this.menuList = res.merchantAsConsumerMenu;
          });
        } else if (userRoles && !userRoles.includes('supplier')) {
          import('@/core/helpers/const.js').then((res) => {
            this.menuList = res.merchantMenu;
          });
        } else {
          if (this.currentMerchantObject) {
            import('@/core/helpers/const.js').then((res) => {
              this.menuList = res.supplierMenu;
            });
          } else {
            this.menuList = [];
          }
        }
      } catch (error) {
        this.menuList = [];
      }
    },
    addtab(href, title) {},
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
  },
};
</script>
<style scoped>
.zoom {
  zoom: 0.4;
}
</style>
